import { env } from "@/env.setup"
import { isPreviewSubdomain } from "@/config/subdomains"

const REQUESTED_DOMAIN_PARTS = window.location.hostname.split('.');
const REQUESTED_SUBDOMAIN = REQUESTED_DOMAIN_PARTS[0];
export const IS_PREVIEW = isPreviewSubdomain(REQUESTED_SUBDOMAIN)

export const IS_OTP_GRAPHQL_PREVIEW_AVAILABLE = IS_PREVIEW && !!env.VITE_OTP_GRAPHQL_PREVIEW_URL

export const SHOULD_APPLY_AUTH_GUARD = IS_OTP_GRAPHQL_PREVIEW_AVAILABLE || env.MODE !== 'production'

/**
 * Flag to notify tally services/components to return early 
 * since window.Tally will not or should not be available to the user
 */
export const SHOULD_APPLY_TALLY_GUARD = IS_OTP_GRAPHQL_PREVIEW_AVAILABLE || env.MODE !== 'production' || !window.Tally